import Field from 'Component/Field';
import FIELD_TYPE from 'Component/Field/Field.config';
import Loader from 'Component/Loader';
import {
    CheckoutAddressTable as SourceCheckoutAddressTable
} from 'SourceComponent/CheckoutAddressTable/CheckoutAddressTable.component';
/** @namespace Bodypwa/Component/CheckoutAddressTable/Component */
export class CheckoutAddressTableComponent extends SourceCheckoutAddressTable {
    renderHeading() {
        const { title, isSelected } = this.props;

        if (!title) {
            return null;
        }

        return (
            <div>
                <p
                  block="KeyValueTable"
                  elem="Heading"
                  colSpan={ 2 }
                >
                    <Field
                      type={ FIELD_TYPE.radio }
                      attr={ {
                          id: `option-${ title.replace(' ', '_') }`,
                          name: `option-${ title.replace(' ', '_') }`,
                          checked: isSelected
                      } }
                      isDisabled
                    />
                    <strong>{ title }</strong>
                </p>
            </div>
        );
    }

    renderTableRow = (data) => {
        const { key } = data;
        const value = this.getValueFromSource(data);

        if (!value) {
            return null;
        }

        return (
            <li key={ key }>
                { value }
            </li>
        );
    };

    renderTable() {
        const { isSelected } = this.props;
        return (
            <button
              block="CheckoutAddressTable"
              elem="Button"
              type="button"
              mods={ { isSelected } }
              onClick={ this.onAddressClick }
            >
                <div block="KeyValueTable" elem="Wrapper">
                    <div block="KeyValueTable">
                        { this.renderHeading() }
                        <ul>
                            { this.dataPairArray.map(this.renderTableRow) }
                        </ul>
                    </div>
                </div>
            </button>
        );
    }

    render() {
        const { countries } = this.props;

        return (
            <div block="CheckoutAddressTable">
                <Loader isLoading={ !countries.length } />
                { this.renderTable() }
            </div>
        );
    }
}

export default CheckoutAddressTableComponent;
